import * as React from 'react';
import { gold, fontBrand, black, white } from '../../../../getLPTheme.tsx';
import 'react-multi-carousel/lib/styles.css';
import { Button, Input,  Stack} from "@mui/material";
import Container from '@mui/material/Container';
import { Box, Typography } from "@mui/material";
import MapInit from './mapInitContent.tsx'
import NewMarker from './mapNewMarker.tsx'
import TablePoints from '../metrics/ListItems/itemsTableContainer.tsx'
import ButtonMarkerExcel from './mapButtonExcelContent.tsx' 


//-------------------- Funcion principal exportada --------------------

export default function GestionarClubes () {

  return (
    <Box>
      <Box
        sx={{
          width: { xs: 360, sm: 600, md: 900, xl: 1024 },
          maxWidth: "100%",
          margin: "0 auto",
          backgroundColor: black[1000],
        }}
      >

        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: black[1000],
            pt: { xs: 0, sm: 0 },
            width: "100%",
            overflowX: "hidden",   // clave
          }}
        >
          <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '70%',  } }}>
            <Typography 
              fontFamily={fontBrand.principal}
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignSelf: 'center',
                textAlign: 'center',
                fontSize: '5vw',
                color: "white"
              }}
            >
              Puntos Asociados 
            </Typography>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <Box sx={{ width: "100%", maxWidth: 520 }}>
                <NewMarker />
              </Box>
            </Box>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  width: "100%",
                  maxWidth: 520,
                  bgcolor: gold[500],
                  borderRadius: 2,
                  px: 1,
                }}
              >
                <Input
                  id="place-input"
                  fullWidth
                  disableUnderline
                  placeholder="Buscar dirección…"
                  sx={{
                    color: white[50],
                    fontFamily: fontBrand.principal,
                    py: 1,
                    "& input::placeholder": { color: "rgba(255,255,255,0.75)", opacity: 1 },
                  }}
                />
              </Box>
            </Box>

            <Box sx={{ width:"100%", display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
              <Box  sx={{ width:{xs:"80%", sm:"50%", md:"50%"}, display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
                <MapInit/>
              </Box>
            </Box>
          </Stack>
          <Box sx={{pt:3, width:"100%", display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
            <ButtonMarkerExcel/>
          </Box>
          <Box
            sx={{
              pt: 3,
              width: "100%",
              maxWidth: "100%",
              overflowX: "hidden",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box sx={{ width: { xs: "100%", sm: "95%" }, minWidth: 0 }}>
              <TablePoints />
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}